import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';

const PrivacyPolicy: React.FC = () => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <Header />
            <main className="flex-grow-1 py-5">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto">
                            <h1 className="mb-4">Privacy Policy</h1>
                            <p className="text-muted mb-4">
                                Last updated: {new Date().toLocaleDateString()}
                            </p>

                            <section className="mb-4">
                                <h2>Information We Collect</h2>
                                <p>
                                    We collect information you provide directly to us, such as when
                                    you create an account, subscribe to our service, or contact us
                                    for support.
                                </p>
                                <ul>
                                    <li>Email addresses and contact information</li>
                                    <li>Account credentials and profile information</li>
                                    <li>Payment information (processed securely through Stripe)</li>
                                    <li>
                                        Email content that you choose to forward through our service
                                    </li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h2>How We Use Your Information</h2>
                                <p>We use the information we collect to:</p>
                                <ul>
                                    <li>
                                        Provide, maintain, and improve our email forwarding service
                                    </li>
                                    <li>Process transactions and send related information</li>
                                    <li>Send technical notices and support messages</li>
                                    <li>Respond to your comments and questions</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h2>Information Sharing</h2>
                                <p>
                                    We do not sell, trade, or otherwise transfer your personal
                                    information to third parties except:
                                </p>
                                <ul>
                                    <li>With your consent</li>
                                    <li>To comply with legal obligations</li>
                                    <li>To protect our rights and safety</li>
                                    <li>
                                        With service providers who assist in our operations (like
                                        Stripe for payments)
                                    </li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h2>Data Security</h2>
                                <p>
                                    We implement appropriate security measures to protect your
                                    personal information against unauthorized access, alteration,
                                    disclosure, or destruction.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h2>Your Rights</h2>
                                <p>You have the right to:</p>
                                <ul>
                                    <li>Access and update your personal information</li>
                                    <li>Delete your account and associated data</li>
                                    <li>Opt out of non-essential communications</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h2>Contact Us</h2>
                                <p>
                                    If you have questions about this Privacy Policy, please contact
                                    us at: privacy (at) pressforwardmail.com
                                </p>
                            </section>
                        </Col>
                    </Row>
                </Container>
            </main>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
